import React from "react";
import { usePagination, DOTS } from "../../../utils/usePagination";
import styles from './pagination.module.css';

const Pagination = (props: any) => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className,
    } = props;

    const paginationRange: any = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize,
    });

    if (currentPage === 0 || paginationRange && paginationRange?.length < 1) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    const lastPage = paginationRange[paginationRange?.length - 1] || 1;

    return (
        <div
            className={styles.paginationContainer}
        >
            <div
                className={
                    currentPage === 1
                        ? `${styles.disabledArrow} ${styles.paginationDiv}` : styles.paginationDiv}
                onClick={onPrevious}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#191c21"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </div>
            <div className={styles.paginationInnerContainer}>
                {paginationRange.map((pageNumber: any, index: any) => {
                    if (pageNumber === DOTS) {
                        return (
                            <li
                                key={index}
                                className={styles.pageNumberBox}
                            >
                                ...
                            </li>
                        );
                    }

                    return (
                        <li key={index}
                            className={`${styles.pageNumberBox} ${pageNumber === currentPage ? styles.activePage : ''}`}
                            onClick={() => onPageChange(pageNumber)}
                        >
                            {pageNumber}
                        </li>
                    );
                })}
            </div>

            <div
                className={`
                           ${currentPage === lastPage ? `${styles.disabledArrow} ${styles.paginationDiv}` : styles.paginationDiv
                    }`}
                onClick={onNext}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#191c21"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </div>
        </div>
    );
};

export default Pagination;
